module.exports = __webpack_public_path__ + "img/logo.8de6c782.svg";